/* lp-ffb: page-owned script for the Four Flavor Box sections (lp-ffb-*), Daphne WS-VANDY-0002.
   One selection for every buy box on the page (they all render snippets/lp-ffb-buybox.liquid),
   the button label from each box's own setting plus the selected price, the add to cart
   (the theme's AJAX cart endpoint with the drawer sections), the sticky bar, scroll links, cart
   re-entry and the flavor rail dots and the hero photo slideshow. Safe to load more than once:
   it initialises once and re-binds on theme-editor section loads.
   Tracking: this script sends no pixel events. Meta AddToCart comes from Elevar (GTM-KW9V3CXC,
   dl_add_to_cart after /cart/add.js succeeds, with an event id for server dedup) and GA4
   add_to_cart from the Google & YouTube app's standard event; a manual fbq/gtag call here
   doubled both (2026-10-02). Don't add one back. */
(function () {
  if (window.lpFfb) { window.lpFfb.init(); return; }

  var picked = null;
  var busy = false;
  var observers = [];

  function all(sel, ctx) { return [].slice.call((ctx || document).querySelectorAll(sel)); }
  function money(n) { return '$' + n.toFixed(2); }
  function whole(n) { return '$' + Math.floor(n); }
  function priceFor(t) { return parseFloat(t.getAttribute('data-price-onetime')); }
  function compareFor(t) { var c = parseFloat(t.getAttribute('data-compare')); return c > priceFor(t) ? c : null; }
  function isBuyable(t) { return /^\d+$/.test(t.getAttribute('data-variant') || ''); }
  function tiers() { return all('[data-ffb-tier]'); }
  function selected() {
    var ts = tiers();
    var hit = ts.filter(function (t) { return t.getAttribute('data-variant') === picked; })[0];
    return hit || ts.filter(function (t) { return t.getAttribute('aria-checked') === 'true'; })[0] || ts[0] || null;
  }

  function render() {
    var sel = selected();
    if (!sel) return;
    picked = sel.getAttribute('data-variant');
    var price = priceFor(sel), was = compareFor(sel), name = sel.getAttribute('data-name');
    tiers().forEach(function (t) {
      var c = compareFor(t), s = t.querySelector('[data-ffb-was]');
      if (s) { if (c) { s.innerHTML = '<span class="vh">Compare at </span>' + whole(c); s.hidden = false; } else { s.hidden = true; } }
      var on = t.getAttribute('data-variant') === picked;
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
    all('[data-ffb-add]').forEach(function (b) {
      var label = b.getAttribute('data-cta-text') || 'Add to cart';
      b.innerHTML = label + ' <span class="fb-sep" aria-hidden="true">·</span> ' + money(price);
      if (isBuyable(sel)) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true');
    });
    all('[data-ffb-sticky-line]').forEach(function (line) {
      line.innerHTML = '<b>' + name + '</b> · ' + money(price) + (was ? '<s><span class="vh">compare at </span>' + whole(was) + '</s>' : '');
    });
  }

  function lastBox() { var b = all('[data-ffb-box]'); return b[b.length - 1] || null; }
  function firstBox() { return all('[data-ffb-box]')[0] || null; }

  function openCart(trigger) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(trigger); return; }
    var bubble = document.querySelector('#cart-icon-bubble');
    if (bubble) { bubble.click(); return; }
    window.location = window.Shopify.routes.root + 'cart';
  }

  function addToCart() {
    var t = selected();
    if (!t || busy || !isBuyable(t)) return;
    busy = true;
    all('[data-ffb-add]').forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(t.getAttribute('data-variant'), 10), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || state.message);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state);
        else window.location = window.Shopify.routes.root + 'cart';
      })
      .catch(function () { window.location = window.Shopify.routes.root + 'cart'; })
      .finally(function () { busy = false; all('[data-ffb-add]').forEach(function (b) { b.removeAttribute('aria-busy'); }); });
  }

  function bindOnce(el, key, fn) {
    if (el.getAttribute('data-ffb-bound-' + key)) return;
    el.setAttribute('data-ffb-bound-' + key, '1');
    fn(el);
  }

  function watchSticky() {
    observers.forEach(function (o) { o.disconnect(); });
    observers = [];
    var bars = all('[data-ffb-sticky]');
    if (!bars.length) return;
    // the bar hides while any buy box, or a section that carries its own buy button, is on screen
    var boxes = all('[data-ffb-box], [data-ffb-hide-sticky]');
    if (!boxes.length) { bars.forEach(function (b) { b.classList.remove('is-visible'); }); return; }
    var seen = boxes.map(function (box) { var r = box.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; });
    function sync() { bars.forEach(function (b) { b.classList.toggle('is-visible', seen.indexOf(true) === -1); }); }
    if (!('IntersectionObserver' in window)) { bars.forEach(function (b) { b.classList.add('is-visible'); }); return; }
    boxes.forEach(function (box, i) {
      var o = new IntersectionObserver(function (es) { es.forEach(function (e) { seen[i] = e.isIntersecting; }); sync(); }, { rootMargin: '-60px 0px 0px 0px' });
      o.observe(box);
      observers.push(o);
    });
    sync();
  }

  function init() {
    all('[data-ffb-tier]').forEach(function (t) {
      bindOnce(t, 'tier', function () {
        t.addEventListener('click', function () { picked = t.getAttribute('data-variant'); render(); });
        t.addEventListener('keydown', function (e) {
          var group = all('[data-ffb-tier]', t.parentNode), i = group.indexOf(t), next = null;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = group[(i + 1) % group.length];
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = group[(i - 1 + group.length) % group.length];
          if (next) { e.preventDefault(); picked = next.getAttribute('data-variant'); render(); next.focus(); return; }
          if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); picked = t.getAttribute('data-variant'); render(); }
        });
      });
    });
    all('[data-ffb-add]').forEach(function (b) {
      bindOnce(b, 'add', function () { b.addEventListener('click', function () { if (b.getAttribute('aria-disabled') !== 'true') addToCart(); }); });
    });
    all('[data-ffb-scroll]').forEach(function (b) {
      bindOnce(b, 'scroll', function () {
        b.addEventListener('click', function () {
          // data-ffb-scroll="first": back up to the first box, showing its section from the top
          // (the hero's headline and rating); otherwise the last box, centred
          if (b.getAttribute('data-ffb-scroll') === 'first') {
            var first = firstBox();
            var top = first && (first.closest('section') || first);
            if (top) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            var target = lastBox();
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      });
    });
    all('[data-ffb-cart]').forEach(function (b) {
      bindOnce(b, 'cart', function () { b.addEventListener('click', function () { openCart(b); }); });
    });
    all('[data-ffb-rail]').forEach(function (rail) {
      bindOnce(rail, 'rail', function () {
        var dots = all('[data-ffb-dots] i', rail.parentNode);
        if (!dots.length) return;
        rail.addEventListener('scroll', function () {
          var cards = rail.children, best = 0, bd = 1e9, left = rail.getBoundingClientRect().left;
          for (var i = 0; i < cards.length; i++) { var d = Math.abs(cards[i].getBoundingClientRect().left - left - 20); if (d < bd) { bd = d; best = i; } }
          dots.forEach(function (d, i) { d.classList.toggle('is-on', i === best); });
        }, { passive: true });
      });
    });
    all('[data-ffb-slides]').forEach(function (box) { bindOnce(box, 'slides', function () { bindSlides(box); }); });
    render();
    watchSticky();
  }

  // hero slideshow: native scroll-snap does the swiping; this adds dots, arrows, optional
  // auto-advance (off unless the section turns it on; never with reduced motion) and the theme
  // editor's block select. Any touch, click or keyboard focus in the photos stops auto-advance.
  function bindSlides(box) {
    var rail = box.querySelector('[data-ffb-slide-rail]');
    if (!rail) return;
    var n = rail.children.length;
    if (n < 2) return;
    var dots = all('[data-ffb-slide-dot]', box), timer = null, hover = false;
    function index() { return Math.round(rail.scrollLeft / Math.max(rail.clientWidth, 1)); }
    function go(i, smooth) { i = (i + n) % n; rail.scrollTo({ left: i * rail.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' }); }
    function mark() {
      var i = index();
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    rail.addEventListener('scroll', mark, { passive: true });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { stop(); go(k); }); });
    var prev = box.querySelector('[data-ffb-slide-prev]'), next = box.querySelector('[data-ffb-slide-next]');
    if (prev) prev.addEventListener('click', function () { stop(); go(index() - 1); });
    if (next) next.addEventListener('click', function () { stop(); go(index() + 1); });
    ['pointerdown', 'touchstart', 'focusin', 'keydown'].forEach(function (ev) { box.addEventListener(ev, stop, { passive: true }); });
    box.addEventListener('mouseenter', function () { hover = true; });
    box.addEventListener('mouseleave', function () { hover = false; });
    var secs = parseInt(box.getAttribute('data-autoplay'), 10) || 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (secs > 0 && !reduce) {
      timer = setInterval(function () {
        if (!document.documentElement.contains(rail)) { stop(); return; }
        if (hover || document.hidden) return;
        go(index() + 1);
      }, secs * 1000);
    }
    box.ffbGo = function (i) { stop(); go(i, false); };
    mark();
  }

  // theme editor: selecting a Photo block shows that photo
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target, box = slide && slide.closest ? slide.closest('[data-ffb-slides]') : null;
    if (box && box.ffbGo) box.ffbGo([].indexOf.call(slide.parentNode.children, slide));
  });

  window.lpFfb = { init: init, render: render };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { setTimeout(init, 0); });
  document.addEventListener('shopify:section:reorder', watchSticky);
})();
